module.exports = __webpack_public_path__ + "img/P2-A7.6e2bb763.svg";